import { AxiosResponse } from 'axios';
import api from '../Api'
import { Dayjs } from "dayjs";

export const getReportTicketSalesRank = (startDate: string, endDate: string): Promise<AxiosResponse<Array<ITicketSalesRankData>, any>> => {
    return api.get(`admin/report/ticket/sales?startDate=${startDate}&endDate=${endDate}`)
}

export const getReportTicketRetention = (): Promise<AxiosResponse<Array<ITicketRetentionData>, any>> => {
    return api.get(`admin/report/ticket/retention`)
}

export const getReportTicketConversion = ({ start, end }: { start: Dayjs, end: Dayjs }): Promise<AxiosResponse<Array<ITicketConversionData>, any>> => {
    return api.get(`admin/report/ticket/conversion?start=${encodeURIComponent(start.toISOString())}&end=${encodeURIComponent(end.toISOString())}`)
}

export const getReportTicketUsableCntToPrice = () => {
    return api.get<IReportTicketUsableCntToPriceAdminResponse[]>(`report/ticket/usable-cnt-to-price/admin`)
}